import { createContext } from 'react';

// A row of its own, or a parent's current step, whose running pill is quiet
export type FeedRowRole = 'card' | 'step';

export const FeedRowRoleContext = createContext<FeedRowRole>('card');
